import { gql } from '@apollo/client';

export const GET_ONBOARDING_SETTINGS = gql`
  query GetOnboardingSettings {
    onboardingSetting {
      apartmentsDefault {
        id
      }
      hotelsDefaut {
        id
      }
      hotelsDefaultLogo {
        id
        url
        formats
      }
      apartmentsDefaultLogo {
        id
        url
        formats
      }
    }
  }
`;
